<template lang="pug">
  div
    dados-oficio(
      :oficio="oficio"
      :isMatricula="true"
    )

    dados-portaria(
      :portaria="portaria"
      )

    dados-processo(
      :processo="processo"
    )

</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import DadosOficio from '@/screens/arrecadacao/cpat/components/oficio/DadosOficio'
import DadosPortaria from '@/screens/arrecadacao/cpat/components/oficio/DadosPortaria'
import DadosProcesso from '@/screens/arrecadacao/cpat/components/oficio/DadosProcesso'

export default {
  components: {
    Divider,
    DadosOficio,
    DadosPortaria,
    DadosProcesso
  },

  props: {
    oficio: {
      required: true,
      type: Object
    }
  },

  computed: {
    processo () {
      return this.oficio.processo
    },

    cartorio () {
      return this.oficio.cartorio
    },
    portaria () {
      return this.oficio.processo.portaria
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/matricula/InformarDadosMatricula.vue